"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseChip = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _designTokens = require("@smartsheet/design-tokens");
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _ursaIcons = require("@smartsheet/ursa-icons");
var _react = _interopRequireWildcard(require("react"));
var _spacing = require("../../../constants/spacing");
var _useTheme = require("../../../theme/utils/useTheme");
var _useOverflowTooltip = require("../../../util/useOverflowTooltip");
var _tooltip = require("../../tooltip");
var _ChipLabel = require("../components/ChipLabel");
var _ChipContainer = require("../styled/ChipContainer");
var _ChipRemoveButton = require("../styled/ChipRemoveButton");
var _chipConstants = require("../styled/chipConstants");
const elementIsScrollable = elem => {
  return !!elem && (elem.offsetHeight < elem.scrollHeight || elem.offsetWidth < elem.scrollWidth);
};
const BaseChip = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledby,
    "aria-describedby": ariaDescribedBy,
    children,
    className,
    color: colorVariant = "neutral",
    onKeyDown,
    onRemove,
    clientId,
    isReadonly = false,
    contentBefore,
    omitTooltip = false,
    size = "medium",
    ...rest
  } = _ref;
  const {
    isActive,
    ...handlers
  } = (0, _lodestarUtils.useActive)();
  const isInteractive = !isReadonly;
  const handleRemove = event => {
    if (isInteractive) {
      onRemove?.(event);
    }
  };
  const handleKeyDown = event => {
    // allow navigation even if chip is read only
    onKeyDown?.(event);
    if (isInteractive) {
      switch (event.key) {
        case "Backspace":
        case "Delete":
          handleRemove(event);
      }
    }
  };
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const buttonProps = onRemove ? {
    role: "button",
    onKeyDown: handleKeyDown,
    tabIndex: 0
  } : {};
  const {
    showOverflowTooltip,
    tooltipProps,
    targetProps,
    elementToMeasureRef
  } = (0, _useOverflowTooltip.useOverflowTooltip)({
    tooltipTargetRef: ref,
    elementIsOverflowing: elementIsScrollable,
    onBlur: rest.onBlur,
    onFocus: rest.onFocus,
    onMouseEnter: rest.onMouseEnter,
    onMouseLeave: rest.onMouseLeave,
    isDisabled: omitTooltip
  });
  const colorProperties = (0, _chipConstants.getTokenForColor)(colorVariant, themeMode);
  return /*#__PURE__*/_react.default.createElement(_ChipContainer.ChipContainer, (0, _extends2.default)({
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledby,
    "aria-describedby": ariaDescribedBy,
    "aria-disabled": isReadonly || undefined,
    "data-client-id": clientId,
    className: className,
    isReadonly: isReadonly,
    themeMode: themeMode,
    size: size
  }, buttonProps, rest, targetProps, {
    style: {
      // We'll apply these properties here so we don't have to generate as much
      // CSS for the Chips. This is good for readability and performance.
      [_chipConstants.chipCustomCssProperties.text]: `var(--smar--sds--chip--label--color, ${(0, _designTokensReact.color)(colorProperties.text, _designTokens.lodestarColors.neutralDark40)})`,
      [_chipConstants.chipCustomCssProperties.backgroundRest]: (0, _designTokensReact.color)(colorProperties.backgroundRest, _designTokens.lodestarColors.buttonDefault),
      [_chipConstants.chipCustomCssProperties.backgroundHover]: (0, _designTokensReact.color)(colorProperties.backgroundHover, _designTokens.lodestarColors.buttonDefault),
      [_chipConstants.chipCustomCssProperties.backgroundActive]: (0, _designTokensReact.color)(colorProperties.backgroundActive, _designTokens.lodestarColors.buttonDefault),
      ...rest.style
    }
  }), contentBefore, /*#__PURE__*/_react.default.createElement(_ChipLabel.ChipLabel, {
    ref: elementToMeasureRef,
    size: size
    // We're going to apply our own here.
    ,
    omitTooltip: true
  }, children), !isReadonly && onRemove ? /*#__PURE__*/_react.default.createElement(_ChipRemoveButton.ChipRemoveButton, (0, _extends2.default)({
    "aria-hidden": true,
    isReadonly: isReadonly
  }, handlers, {
    isActive: isActive,
    onClick: handleRemove,
    themeMode: themeMode,
    size: size
  }), /*#__PURE__*/_react.default.createElement(_ursaIcons.CloseIcon, {
    size: _spacing.sizes.medium
  })) : null, showOverflowTooltip && /*#__PURE__*/_react.default.createElement(_tooltip.Tooltip, tooltipProps, /*#__PURE__*/_react.default.createElement(_tooltip.TooltipBody, null, children)));
});
exports.BaseChip = BaseChip;
BaseChip.displayName = "BaseChip";
//# sourceMappingURL=BaseChip.js.map